export const ALL_BATTERY_TYPES = 'all_battery_types';

export interface BatteryTypeOption {
  batteryType: string;
  label: string;
}

export const ALL_BATTERY_TYPES_OPTION: BatteryTypeOption = {
  batteryType: ALL_BATTERY_TYPES,
  label: 'Entire fleet'
};

export function toBatteryTypeLabel(batteryType: string): string {
  if (batteryType === ALL_BATTERY_TYPES) {
    return ALL_BATTERY_TYPES_OPTION.label;
  }
  return batteryType.replace(/_/g, ' ');
}

export function toBatteryTypeSlug(batteryType: string): string {
  return batteryType.replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-|-$/g, '').toLowerCase();
}

export function toBatteryTypeFilter(batteryTypes: BatteryTypeOption[]): string[] {
  return batteryTypes
    .filter((option) => option?.batteryType)
    .map((option) => option.batteryType);
}

/**
 * Maps the `/battery-type/{id}` response (`{ batteryType: string[] }`) into the option
 * list used by the selector. Duplicates and empty values are discarded while the
 * original order is preserved.
 */
export function toBatteryTypeOptions(response: any): BatteryTypeOption[] {
  const batteryTypes: string[] = Array.isArray(response?.batteryType) ? response.batteryType : [];
  const distinct = Array.from(
    new Set(batteryTypes.filter((batteryType): batteryType is string => typeof batteryType === 'string' && batteryType !== ''))
  );

  return distinct.map((batteryType) => ({
    batteryType,
    label: toBatteryTypeLabel(batteryType)
  }));
}

export const BATTERY_TYPE_COLORS = ['#007BC0', '#18837E', '#9E2896'];

export interface BatteryTypeSeries extends BatteryTypeOption {
  color: string;
  datapoints: any[];
}

export function toBatteryTypeSeries(response: any, selected: BatteryTypeOption[]): BatteryTypeSeries[] {
  const entries = Object.values(response ?? {}).flatMap((value: any) => (Array.isArray(value) ? value : []));

  return selected.map((option, index) => ({
    ...option,
    color: BATTERY_TYPE_COLORS[index % BATTERY_TYPE_COLORS.length],
    datapoints: entries.filter((entry: any) => (entry?.batteryType || ALL_BATTERY_TYPES) === option.batteryType)
  }));
}
